module.exports = __webpack_public_path__ + "static/media/Fish Games.6a5b1eee.svg";